import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { all_routes } from '../../../router/all_routes'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import PredefinedDateRanges from '../../../../core/common/datePicker'
import { allClass, names } from '../../../../core/common/selectoption/selectoption'
import TeacherModal from '../teacherModal'
import CommonSelect from '../../../../core/common/commonSelect'
import TooltipOption from '../../../../core/common/tooltipOption'
import UserService from '../../../network/services/UserService'
import { getUser } from '../../../network/auth/Auth'

const TeacherGrid = () => {
  const routes = all_routes
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove('show');
    }
  };


  interface TeacherData {
    id: any;
    partner_id: any;
    first_name: any;
    last_name: any;
    birth_date: any;
    blood_group: any;
    gender: any;
    nationality: any;
    main_department_id: any;
    allowed_department_ids: any;
    active: any;
    session_ids: any;
    operating_branch_id: any;
    faculty_subject_ids: any;
    company_id: any

  }
  interface Option {
    id: any;
    name: any;
  }

  const [teachers, setTeachers] = useState<TeacherData[]>([]);
  const [branch, setBranch] = useState<any>();
  const branches = getUser()?.company_ids[0]?.branches;



  const fetchData = async (branch_id: any, company_id: any, item: any) => {
    if (item) {
      setBranch(item.name);
    }
    setIsLoading(true)
    UserService.getTeachersByBranchAndComapny(branch_id, company_id, (response: any) => {
      if (response?.data && response?.success) {
        setIsLoading(false)
        setTeachers(response.data);
      } else {
        setIsLoading(false)
        setTeachers([]);
      }
    });
  };


  const fetchDataInit = async (company_id: any) => {
    setBranch('All');
    setIsLoading(true)
    await UserService.getTeachersByBranchAndComapnyAll(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setIsLoading(false)

        setTeachers(response.data);

      }
    })

  };

  useEffect(() => {
    fetchDataInit(getUser()?.company_ids[0]?.id);
  }, []);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content content-two">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Teachers </h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Peoples</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Teachers{" "}
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />

              <div className="mb-2">
                <Link
                  to={routes.addTeacher}
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Teacher
                </Link>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="bg-white p-3 border rounded-1 d-flex align-items-center justify-content-between flex-wrap mb-4 pb-0">
            <h4 className="mb-3">Teachers Grid</h4>
            <div className="d-flex align-items-center flex-wrap">
              <div className="input-icon-start mb-3 me-2 position-relative">
                <PredefinedDateRanges />
              </div>
              <div className="dropdown mb-3 me-2">
                <Link
                  to="#"
                  className="btn btn-outline-light bg-white dropdown-toggle"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                >
                  <i className="ti ti-filter me-2" />
                  Filter
                </Link>
                <div className="dropdown-menu drop-width" ref={dropdownMenuRef}>
                  <form >
                    <div className="d-flex align-items-center border-bottom p-3">
                      <h4>Filter</h4>
                    </div>
                    <div className="p-3 pb-0 border-bottom">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Name</label>
                            <CommonSelect
                              className="select"
                              options={names}
                              defaultValue={names[0]}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Class</label>
                            <CommonSelect
                              className="select"
                              options={allClass}
                              defaultValue={allClass[0]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-3 d-flex align-items-center justify-content-end">
                      <Link to="#" className="btn btn-light me-3">
                        Reset
                      </Link>
                      <Link to={routes.teacherGrid} onClick={handleApplyClick} className="btn btn-primary">
                        Apply
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
              <div className="d-flex align-items-center bg-white border rounded-2 p-1 mb-3 me-2">
                <Link
                  to={routes.teacherList}
                  className=" btn btn-icon btn-sm me-1 bg-light primary-hover"
                >
                  <i className="ti ti-list-tree" />
                </Link>
                <Link
                  to={routes.teacherGrid}
                  className=" active btn btn-icon btn-sm  primary-hover"
                >
                  <i className="ti ti-grid-dots" />
                </Link>
              </div>
              <div className="dropdown mb-3">
                <Link to="#" className="btn btn-outline-light bg-white dropdown-toggle" data-bs-toggle="dropdown">
                  <i className="ti ti-sort-ascending-2 me-2" />
                  {branch}
                </Link>
                <ul className="dropdown-menu p-3">
                  <li >
                    <a className="dropdown-item rounded-1" onClick={() => fetchDataInit(getUser()?.company_ids[0]?.id)}>
                      All
                    </a>
                  </li>
                  {branches?.map((item: any) => (
                    <li key={item.id}>
                      <a className="dropdown-item rounded-1" onClick={() => fetchData(item.id, getUser()?.company_ids[0]?.id, item)}>
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            {teachers && teachers?.map((item: any, index: any) => (
              <div className="col-xxl-3 col-xl-4 col-md-6 d-flex">
                <div className="card flex-fill">
                  <div className="card-header d-flex align-items-center justify-content-between">
                    <Link to={routes.teacherDetails} className="link-primary">
                      T849127
                    </Link>
                    <div className="d-flex align-items-center">
                      {item?.partner_id?.active ? (
                        <span className="badge badge-soft-success d-inline-flex align-items-center me-1">
                          <i className="ti ti-circle-filled fs-5 me-1" />
                          Active
                        </span>
                      ) : (
                        <span className="badge badge-soft-danger d-inline-flex align-items-center me-1">
                          <i className="ti ti-circle-filled fs-5 me-1" />
                          Inactive
                        </span>
                      )
                      }
                      <div className="dropdown">
                        <Link
                          to="#"
                          className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="ti ti-dots-vertical fs-14" />
                        </Link>
                        <ul className="dropdown-menu dropdown-menu-right p-3">
                          <li>
                            <Link
                              className="dropdown-item rounded-1"
                              to={routes.editTeacher}
                            >
                              <i className="ti ti-edit-circle me-2" />
                              Edit
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item rounded-1"
                              to="#"
                              data-bs-toggle="modal"
                              data-bs-target="#delete-modal"
                            >
                              <i className="ti ti-trash-x me-2" />
                              Delete
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="bg-light-300 rounded-2 p-3 mb-3">
                      <div className="d-flex align-items-center">
                        <Link
                          to={routes.teacherDetails}
                          className="avatar avatar-lg flex-shrink-0"
                        >
                          <img
                            src={`data:image/png;base64,${item?.partner_id?.avatar}`}
                            className="img-fluid rounded-circle"
                            alt="img"
                          />
                        </Link>
                        <div className="ms-2">
                          <h6 className="text-dark text-truncate mb-0">
                            <Link to={routes.teacherDetails}>{item?.partner_id?.name}</Link>
                          </h6>
                          <p>III A</p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="mb-2">
                        <p className="mb-0">Email</p>
                        <p className="text-dark">{item?.partner_id?.email}</p>
                      </div>
                      <div>
                        <p className="mb-0">Phone</p>
                        <p className="text-dark">{item?.partner_id?.phone}</p>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer d-flex align-items-center justify-content-between">
                    <span className="badge badge-soft-danger">{item?.faculty_subject_ids[0]?.name}</span>
                    <Link to={routes.teacherDetails} className="btn btn-light btn-sm">
                      View Details
                    </Link>
                  </div>
                </div>
              </div>
            ))

            }

            {/* /Teacher Grid */}
            <div className="text-center">
              {
                isLoading ? (<Link to="#" className="btn btn-primary">
                  <span
                    className="spinner-border spinner-border-sm align-middle me-1"
                    role="status"
                    aria-hidden="true"
                  />
                  Load More ...
                </Link>) : (<Link to="#" className="btn btn-primary">
                  <i className="ti ti-loader-3 me-2" />
                  Load More
                </Link>)
              }
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <TeacherModal />
    </>

  )
}

export default TeacherGrid